// extracted by mini-css-extract-plugin
export var desktopLogo = "Navbar-module--desktop-logo--6f2c4";
export var displayName = "Navbar-module--display-name--95eef";
export var inner = "Navbar-module--inner--ef61b";
export var leftContainer = "Navbar-module--left-container--88a46";
export var logo = "Navbar-module--logo--8d802";
export var logoContainer = "Navbar-module--logo-container--6ff6f";
export var nav = "Navbar-module--nav--a5f89";
export var rightContainer = "Navbar-module--right-container--653d0";